import * as z from 'zod';

import { categoryQuerySchema } from '@/_pages/settings/categories/shared/schemas';
import { manufacturerQuerySchema } from '@/_pages/settings/manufacturers/shared';
import { currencyInput, nullableNumericBooleanQuerySchema, paginatedResponseSchema } from '@/_schemas/generic';
import { statusQuerySchema } from '@/_schemas/status-input';

import { productAndServicesQueryLinkerSchema } from './product-services-query-linker-schema';

export const productAndServicesCategoryLinkerSchema = categoryQuerySchema.pick({
  id: true,
  name: true,
  wholesale_discount: true,
});

export type ProductAndServicesCategoryLinkerSchema = z.infer<typeof productAndServicesCategoryLinkerSchema>;

export const productAndServicesQuerySchema = z.object({
  ...productAndServicesQueryLinkerSchema.shape,

  category_id: z.number(),
  category: productAndServicesCategoryLinkerSchema,
  type: z.string().nullable(),
  status: statusQuerySchema,

  manufacturer_id: z.number().nullable(),
  manufacturer: manufacturerQuerySchema.nullable(),

  unit_sell_by_id: z.number(),
  price_frequency_id: z.number(),

  list_price_profit: currencyInput.querySchema(),
  landed_cost: currencyInput.querySchema(),
  wholesale_profit: currencyInput.querySchema(),

  product_expires: nullableNumericBooleanQuerySchema(),
  virtual_product: nullableNumericBooleanQuerySchema(),
  client_qty_set: nullableNumericBooleanQuerySchema(),
  wholesale_manual: nullableNumericBooleanQuerySchema(),
});

export type ProductAndServicesQuerySchema = z.infer<typeof productAndServicesQuerySchema>;

export const productAndServicesAllQuerySchema = paginatedResponseSchema(productAndServicesQuerySchema);

export type ProductAndServicesAllQuerySchema = z.infer<typeof productAndServicesAllQuerySchema>;
